webpackJsonp([92409831891434],{

/***/ 560:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(7);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _caseStudyHospitalMortality = __webpack_require__(105);
	
	var _caseStudyHospitalMortality2 = _interopRequireDefault(_caseStudyHospitalMortality);
	
	var _caseStudyNewYork = __webpack_require__(106);
	
	var _caseStudyNewYork2 = _interopRequireDefault(_caseStudyNewYork);
	
	var _caseStudyTwoStates = __webpack_require__(107);
	
	var _caseStudyTwoStates2 = _interopRequireDefault(_caseStudyTwoStates);
	
	var _Button = __webpack_require__(22);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HospitalMortality = function HospitalMortality(_ref) {
	  var data = _ref.data;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'article',
	      { className: 'case_study' },
	      _react2.default.createElement(
	        'div',
	        { className: 'section' },
	        _react2.default.createElement(
	          'div',
	          { className: 'section__row section__row__2_up section__row__reverse' },
	          _react2.default.createElement(
	            'figure',
	            { className: 'section__content section__content__figure case_study__figure' },
	            _react2.default.createElement(
	              'div',
	              { className: 'case_study__figure__wrapper' },
	              _react2.default.createElement(_caseStudyHospitalMortality.ReactComponent, null)
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'section__content section__content__wide' },
	            _react2.default.createElement(
	              'h2',
	              { className: 'title__page__label' },
	              'A Closer Look:'
	            ),
	            _react2.default.createElement(
	              'h1',
	              { className: 'title__page' },
	              'Hospital Mortality'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'The Scorecard measures deaths within 30 days of hospital discharge among Medicare beneficiaries who were treated for four common conditions: heart attack, stroke, congestive heart failure, and pneumonia. Hospital 30-day mortality rates rose in nearly all states between the two measurement periods reported in the Scorecard, driving the national average from 13.2 percent to 14.1 percent.',
	              _react2.default.createElement(
	                'sup',
	                { className: 'note__link' },
	                _react2.default.createElement(
	                  'a',
	                  { href: '#47' },
	                  '47'
	                )
	              ),
	              ' The increase in this rate, which represents a reversal in an earlier improvement trend, appears to be driven by a sharp uptick in mortality among pneumonia patients.'
	            )
	          )
	        )
	      ),
	      _react2.default.createElement('hr', { className: 'section__divider' }),
	      _react2.default.createElement(
	        'div',
	        { className: 'section' },
	        _react2.default.createElement(
	          'div',
	          { className: 'section__row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'section__content section__exhibit' },
	            _react2.default.createElement(
	              'h2',
	              { className: 'exhibit__title__block' },
	              'Hospital mortality has risen among patients admitted for pneumonia'
	            ),
	            _react2.default.createElement(
	              'figure',
	              null,
	              _react2.default.createElement('img', { src: (0, _gatsbyLink.withPrefix)('/img/exhibits/exhibit-box-2-web.png'), alt: '' }),
	              _react2.default.createElement(
	                'figcaption',
	                null,
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'Data: CMS Hospital Compare, 2014 and 2017 4th Quarter, National-Level Summary Estimates.'
	                )
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'section section__case_study__list' },
	      _react2.default.createElement(
	        'div',
	        { className: 'section__row section__row__3_up' },
	        _react2.default.createElement(
	          'div',
	          { className: 'section__content' },
	          _react2.default.createElement(
	            'figure',
	            { className: 'case_study__figure' },
	            _react2.default.createElement(
	              'div',
	              { className: 'case_study__figure__wrapper' },
	              _react2.default.createElement(_caseStudyTwoStates.ReactComponent, null)
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'case_study__content' },
	            _react2.default.createElement(
	              'h4',
	              { className: 'case_study__label' },
	              'A Closer Look:'
	            ),
	            _react2.default.createElement(
	              'h3',
	              { className: 'case_study__title' },
	              'New Hampshire and Maine: Two States Where Medicaid Expansion Is in Flux'
	            ),
	            _react2.default.createElement(_Button2.default, { to: '/case-study/medicaid-expansion-in-flux', text: 'Keep Reading' })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'section__content' },
	          _react2.default.createElement(
	            'figure',
	            { className: 'case_study__figure' },
	            _react2.default.createElement(
	              'div',
	              { className: 'case_study__figure__wrapper' },
	              _react2.default.createElement(_caseStudyHospitalMortality.ReactComponent, null)
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'case_study__content' },
	            _react2.default.createElement(
	              'h4',
	              { className: 'case_study__label' },
	              'A Closer Look:'
	            ),
	            _react2.default.createElement(
	              'h3',
	              { className: 'case_study__title' },
	              'Hospital Mortality'
	            ),
	            _react2.default.createElement(_Button2.default, { to: '/case-study/hospital-mortality', text: 'Keep Reading' })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'section__content' },
	          _react2.default.createElement(
	            'figure',
	            { className: 'case_study__figure' },
	            _react2.default.createElement(
	              'div',
	              { className: 'case_study__figure__wrapper' },
	              _react2.default.createElement(_caseStudyNewYork.ReactComponent, null)
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'case_study__content' },
	            _react2.default.createElement(
	              'h4',
	              { className: 'case_study__label' },
	              'A Closer Look:'
	            ),
	            _react2.default.createElement(
	              'h3',
	              { className: 'case_study__title' },
	              'New York Moves to Improve'
	            ),
	            _react2.default.createElement(_Button2.default, { to: '/case-study/new-york-moves-to-improve', text: 'Keep Reading' })
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'section section__notes' },
	      _react2.default.createElement(
	        'div',
	        { className: 'section__row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'section__content' },
	          _react2.default.createElement(
	            'ol',
	            { start: '47', style: { counterReset: "item 46" }, className: 'list__notes' },
	            _react2.default.createElement(
	              'li',
	              { id: '47' },
	              'The Centers for Medicare and Medicaid Services reports hospital mortality over a three-year time frame.'
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	//  Components
	exports.default = HospitalMortality;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-case-study-hospital-mortality-js-3515a0071d4584195a7b.js